import { tabbable } from "tabbable";
function trapFocus(parent) {
  return (e) => {
    if (e.key === "Tab" && !parent.contains(e.target)) {
      const tabbableElements = tabbable(parent) || [];
      if (tabbableElements.length) {
        if (e.shiftKey) {
          tabbableElements[tabbableElements.length - 1].focus();
        } else {
          tabbableElements[0].focus();
        }
      }
    }
  };
}
function trapFocusIfRepeat(parent) {
  return (e) => {
    if (e.key === "Tab" && e.repeat) {
      trapFocus(parent)(e);
    }
  };
}
function startTrappingFocus(parent) {
  document.addEventListener("keyup", trapFocus(parent));
  document.addEventListener("keydown", trapFocusIfRepeat(parent));
}
function stopTrappingFocus(parent) {
  document.removeEventListener("keyup", trapFocus(parent));
  document.removeEventListener("keydown", trapFocusIfRepeat(parent));
}
export {
  startTrappingFocus,
  stopTrappingFocus
};
